import React, { useEffect, useState } from "react";
import "../Styles/Feefrequency.css";
import { simplePostCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { useParams } from "react-router-dom";
import '../Styles/Registration.css'

export default function Registration() {
  const [isLoading, setIsLoading] = useState(true);
  const [AccountantData, setAccountantData] = useState({});
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      loadDataStudent();
    }
  }, [id]);
  const loadDataStudent = async () => {
    setIsLoading(true);

    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      category_id: Number(id), // 👈 coming from URL param
    };

    try {
      const response = await simplePostCall(
        ApiConfig.feeCategoryview,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        setAccountantData(response.data[0]);
      } else {
        setAccountantData(null);
      }
    } catch (error) {
      console.error("Error loading student:", error);
      setAccountantData(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="registration-wrapper">
      <div className="registration-panel">
        {/* Panel Header */}
        <div className="panel-heading">
          <h3 className="panel-title">Registration</h3>
        </div>

        {/* Panel Body */}
          <div className="panel-body">
            <table className="detail-view-table">
              <tbody>
                <tr>
                  <th>Category Name</th>
                  <td>{AccountantData.fee_category_name}</td>
                </tr>

                <tr>
                  <th>Category Type</th>
                  <td>Fee</td>
                </tr>

                <tr>
                  <th>Amount Type</th>
                  <td>{AccountantData.fee_category_type}</td>
                </tr>

                <tr>
                  <th>Applicable To</th>
                  <td>{AccountantData.fee_category_applicable_to}</td>
                </tr>

                <tr>
                  <th>Category Status</th>
                  <td>{AccountantData.fee_category_status}</td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
    </div>
  );
}
